export default defineNuxtPlugin(async () => {
  let LRUCache: any;
  try {
    const lruModule = await import('lru-cache');
    LRUCache = lruModule.LRUCache;
  } catch (e) {
    console.error('Failed to load lru-cache:', e);
    return;
  }

  // Configure the LRU cache
  const lruCache = new LRUCache({
    max: 500, // Maximum items the cache can hold
    ttl: 1000 * 60 * 10, // Time-to-live (10 minutes)
  });

  // Provide the cache globally
  return {
    provide: {
      lruCache,
    },
  };
});
